module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/head-banner-bg.9856b0a9.jpg";